import './styles.css';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp, FaMapPin, FaPaperPlane, FaChevronRight, FaChevronUp, FaHeart } from 'react-icons/fa';
import logo from '../../assets/image.webp';

function Footer() {

    return (
        <footer className="bg-gray-900 text-white">
            {/* Main Footer Content */}
            <div className="border-b border-gray-800 py-4">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {/* Brand Section */}
                        <div>
                            <div className="mb-6">
                                <img src={logo} alt="Distribuidora York" className="h-24 w-auto object-contain mb-4" />
                            </div>
                            <p className="text-gray-400 mb-6 text-sm leading-relaxed">
                                42 anos de experiência em logística e entrega dos produtos Coca-Cola.
                            </p>
                            <div className="flex space-x-3">
                                <a href="https://www.facebook.com/profile.php?id=100067954752927" target="_blank" rel="noopener noreferrer" 
                                    className="w-10 h-10 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition duration-300">
                                    <FaFacebook size={16} />
                                </a>
                                <a href="https://www.instagram.com/yorkdistribuidora" target="_blank" rel="noopener noreferrer"
                                    className="w-10 h-10 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition duration-300">
                                    <FaInstagram size={16} />
                                </a>
                                <a href="https://www.linkedin.com/company/york-distribuidora-ltda" target="_blank" rel="noopener noreferrer"
                                    className="w-10 h-10 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition duration-300">
                                    <FaLinkedin size={16} />
                                </a>
                                <a href="https://api.whatsapp.com/send/?phone=558632364215" target="_blank" rel="noopener noreferrer"
                                    className="w-10 h-10 bg-gray-800 hover:bg-red-600 rounded-full flex items-center justify-center transition duration-300">
                                    <FaWhatsapp size={16} />
                                </a>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h4 className="text-lg font-bold mb-4 text-red-600">Links Rápidos</h4>
                            <ul className="space-y-2">
                                <li>
                                    <a href="/" className="text-gray-400 hover:text-white transition duration-300 flex items-center">
                                        <FaChevronRight size={12} className="text-red-600 mr-2" />
                                        Início
                                    </a>
                                </li>
                                <li>
                                    <a href="/" className="text-gray-400 hover:text-white transition duration-300 flex items-center">
                                        <FaChevronRight size={12} className="text-red-600 mr-2" />
                                        Sobre Nós
                                    </a>
                                </li>
                                <li>
                                    <a href="/contato" className="text-gray-400 hover:text-white transition duration-300 flex items-center">
                                        <FaChevronRight size={12} className="text-red-600 mr-2" />
                                        Contato
                                    </a>
                                </li>
                                <li>
                                    <a href="/trabalhe-conosco" className="text-gray-400 hover:text-white transition duration-300 flex items-center">
                                        <FaChevronRight size={12} className="text-red-600 mr-2" />
                                        Vagas
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Filiais */}
                        <div>
                            <h4 className="text-lg font-bold mb-4 text-red-600">Nossas Filiais</h4>
                            <ul className="space-y-2">
                                <li className="text-gray-400 flex items-start">
                                    <FaMapPin size={12} className="text-red-600 mr-2 mt-1 flex-shrink-0" />
                                    <span>Teresina - PI</span>
                                </li>
                                <li className="text-gray-400 flex items-start">
                                    <FaMapPin size={12} className="text-red-600 mr-2 mt-1 flex-shrink-0" />
                                    <span>Caxias - MA</span>
                                </li>
                                <li className="text-gray-400 flex items-start">
                                    <FaMapPin size={12} className="text-red-600 mr-2 mt-1 flex-shrink-0" />
                                    <span>Picos - PI</span>
                                </li>
                                <li className="text-gray-400 flex items-start">
                                    <FaMapPin size={12} className="text-red-600 mr-2 mt-1 flex-shrink-0" />
                                    <span>Piripiri - PI</span>
                                </li>
                                <li className="text-gray-400 flex items-start">
                                    <FaMapPin size={12} className="text-red-600 mr-2 mt-1 flex-shrink-0" />
                                    <span>Floriano - PI</span>
                                </li>
                            </ul>
                        </div>

                        {/* Newsletter */}
                        <div>
                            <h4 className="text-lg font-bold mb-4 text-red-600">Newsletter</h4>
                            <p className="text-gray-400 mb-4">Assine nossa newsletter para receber novidades institucionais.</p>
                            <form className="mb-4">
                                <div className="flex">
                                    <input 
                                        type="email" 
                                        placeholder="Seu e-mail"
                                        className="px-4 py-2 rounded-l-lg rounded-r-none w-full focus:outline-none text-gray-900"
                                    />
                                    <button 
                                        type="submit"
                                        className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded-r-lg transition duration-300"
                                    >
                                        <FaPaperPlane size={16} />
                                    </button>
                                </div>
                            </form>
                            <p className="text-xs text-gray-500">
                                Nunca compartilharemos seus dados. Política de privacidade.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Footer */}
            <div className="bg-gray-950 py-6">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center text-center md:text-left">
                        <div>
                            <p className="text-gray-400 text-sm">
                                <span className="font-semibold">CNPJ:</span> 07.230.451/0001-64
                            </p>
                        </div>
                        <div className="border-l border-r border-gray-800 px-4">
                            <p className="text-gray-400 text-sm">
                                &copy; 2026 Distribuidora York. Todos os direitos reservados.
                            </p>
                        </div>
                        <div>
                            <p className="text-gray-400 text-sm flex items-center justify-center md:justify-start">
                                Desenvolvido por Antônio
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Back to Top Button */}
            <a href="#inicio" className="fixed bottom-8 right-8 bg-red-600 hover:bg-red-700 text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-110 opacity-0 hover:opacity-100 z-40" id="backToTop">
                <FaChevronUp size={20} />
            </a>

            <script>
                {`
                    window.addEventListener('scroll', function() {
                        const backToTop = document.getElementById('backToTop');
                        if (window.scrollY > 300) {
                            backToTop.style.opacity = '1';
                        } else {
                            backToTop.style.opacity = '0';
                        }
                    });
                `}
            </script>
        </footer>
    )
}

export default Footer;

